var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27266",
    "data-name": "Rectangle 27266",
    width: 11,
    height: 11,
    transform: "translate(472 449)",
    fill: "#6a6f73",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_439",
    "data-name": "Mask Group 439",
    transform: "translate(-472 -449)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-6_-_2022-01-25T133915.243",
    "data-name": "svgexport-6 - 2022-01-25T133915.243",
    transform: "translate(472 449.319)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10176",
    "data-name": "Group 10176",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10175",
    "data-name": "Group 10175"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10598",
    "data-name": "Path 10598",
    d: "M10.362,1.612a2.186,2.186,0,0,0-3.087,0L2.129,6.758A1.31,1.31,0,1,0,3.981,8.61L8.1,4.494,7.48,3.876,3.364,7.993a.437.437,0,1,1-.617-.617L7.892,2.23A1.31,1.31,0,0,1,9.744,4.082L4.6,9.228A2.183,2.183,0,0,1,1.511,6.14L6.657.995,6.039.377.894,5.523A3.056,3.056,0,0,0,5.216,9.845L10.362,4.7A2.186,2.186,0,0,0,10.362,1.612Z",
    transform: "translate(0 -0.377)",
    fill: "#6a6f73"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFile);
export default __webpack_public_path__ + "static/media/add-file.97696e08831dc209817a3e5b8398573c.svg";
export { ForwardRef as ReactComponent };